import React from "react";

import { Link } from "react-router-dom";
import "./Header.css";
import logoa2z from "../images/logoa2zs.jpg";
import ReactWhatsapp from "react-whatsapp";

function Header() {
  return (


    <>

      <div className="fixed-top">


        <div className="a2zindia">
          <div className="album py-1">

            <div className="container">

              <div className="row ">

                <div className="col-md-4">
                  <div className="d-flex justify-content-between align-items-center">
                    {/* <h4 style={{ color: "Darkblue" }} > <b> {ctime} </b></h4> */}


                    <a href="tel: +91 9732000307" style={{ color: "white", pading: "1px" }} ><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-forward" viewBox="0 0 16 16">
                      <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zm10.762.135a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L14.293 4H9.5a.5.5 0 0 1 0-1h4.793l-1.647-1.646a.5.5 0 0 1 0-.708" />
                    </svg>  +91 9732000307</a>








                  </div>

                </div>

                <div className="d-flex justify-content-between align-items-center">





                </div>
              </div>
            </div>
          </div>
        </div>
        <nav className="navbar navbar-expand-lg navbar bg-white shadow">
          <div className="container-fluid">
            <Link to="/" >
              <div className="radiuslogo">
                <img src={logoa2z} height="50" width="120" alt="logoa2z" />
              </div>
            </Link>

            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <ul className="navbar-nav mx-auto mb-2 mb-lg-0 ">

                <li className="nav-item">
                  <div className="textcolor">
                    <a href="/" className="nav-link active"  style={{color:"#9A6F08"}} aria-current="page"> Home</a>
                  </div>
                </li>
               
                <li className="nav-item">
                <div className="textcolor">
                  <a style={{color:"#9A6F08"}} className="nav-link active" aria-current="page"  href="about">About us</a>
                  </div>
                </li>
               

             


                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="#"  id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <b style={{color:"#9A6F08"}}> Our Services</b>
                  </a>
                  <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                    <li><Link to="#" className="dropdown-item" > <b style={{color:"#9A6F08"}}> Interior</b></Link></li>
                    <li><Link to="/Exterior" className="dropdown-item" > <b style={{color:"#9A6F08"}}> Civil Work and Exterior</b></Link></li>
                                        <li><Link to="/Swimmingpool" className="dropdown-item" > <b style={{color:"#9A6F08"}}> Swimming Pool</b></Link></li>

                    <li><Link to="#" className="dropdown-item" > <b style={{color:"#9A6F08"}}> Water Treatment</b></Link></li>
                    <li><Link to="#" className="dropdown-item" > <b style={{color:"#9A6F08"}}> Air Treatment</b></Link></li>
                    <li><Link to="#" className="dropdown-item" > <b style={{color:"#9A6F08"}}>Dast Treatment</b></Link></li>


                    <li><Link to="/Chimneys" className="dropdown-item" > <b style={{color:"#9A6F08"}}> Chimney's</b></Link></li>
                    <li><Link to="#" className="dropdown-item" > <b style={{color:"#9A6F08"}}> Rooftop garden and lane</b></Link></li>
                    <li><Link to="/solar" className="dropdown-item" ><b style={{color:"#9A6F08"}}> Soler System</b></Link></li>
                    <li><Link to="#" className="dropdown-item" ><b style={{color:"#9A6F08"}}> Event</b></Link></li>




                  </ul>

                </li>

                <li className="nav-item dropdown">
              
                  <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <b style={{color:"#9A6F08"}}> Member</b>
                  </a>
                 
                  <ul className="dropdown-menu" aria-labelledby="navbarDropdown">

                    <li><a href="/Livemember"  className="dropdown-item" > <b style={{color:"#9A6F08"}}> Live Member</b></a></li>






                  </ul>

                </li>

                <li className="nav-item">
                  <Link to="/Contact" style={{color:"#9A6F08"}} className="nav-link active" aria-current="page" > Contact</Link>
                </li>

              </ul>

            

                <a href="https://sso.godaddy.com/?region=eu1&saas=2&app=ox&path=v1%2Fsaml%2Fox&realm=pass&status=24" target="_blank" rel="noopener noreferrer" className="headerlog" type="submit">Login <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" fill="currentColor" class="bi bi-box-arrow-in-right" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M6 3.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-1 0v2A1.5 1.5 0 0 0 6.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-8A1.5 1.5 0 0 0 5 3.5v2a.5.5 0 0 0 1 0v-2z" />
                  <path fill-rule="evenodd" d="M11.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H1.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z" />
                </svg></a>
              
            </div>
          </div>
        </nav>
      </div>
    </>
  );
}

export default Header;